export function focusRecentItemRenameInput(input: HTMLInputElement): void {
  input.focus()

  const length = input.value.length
  const prefersCoarsePointer = typeof window.matchMedia === 'function' &&
    window.matchMedia('(pointer: coarse)').matches

  if (prefersCoarsePointer) {
    input.setSelectionRange(length, length)
    return
  }

  input.select()
}
